import type { CSSProperties, ReactNode } from 'react';
import { cx } from '@/lib/cx';

export interface FormGroupProps {
  label: ReactNode;
  htmlFor: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  note?: ReactNode;
  labelId?: string;
}

/** Prototype .form-group > label + control (CSS line 32). */
export function FormGroup({ label, htmlFor, children, className, style, note, labelId }: FormGroupProps) {
  return (
    <div className={cx('form-group', className)} style={style}>
      <label htmlFor={htmlFor} id={labelId}>
        {label}
      </label>
      {children}
      {note ? <div className="field-note">{note}</div> : null}
    </div>
  );
}
